import React from 'react';
import legalData from '../../data/legalData.json';
import './ModalLegal.css';

const ModalLegal = ({ isOpen, onClose, docType }) => {
  const keyMap = {
    sla: 'slaOpen',
    privacy: 'privacyOpen',
    terms: 'termsOpen',
    contract: 'contractOpen',
    arco: 'arcoOpen'
  };

  const docKey = keyMap[docType] || 'privacyOpen';
  const currentDoc = legalData[docKey] || {
    tag: 'DOCUMENTO LEGAL',
    title: 'Información Legal',
    bodyHtml: '<p>Cargando información...</p>'
  };

  if (!isOpen) return null;

  return (
    <div className="df-legal-modal-overlay" role="dialog" aria-modal="true" aria-labelledby="df-legal-modal-title">
      {/* Fondo oscuro para cerrar al hacer clic */}
      <div className="df-legal-modal-backdrop" onClick={onClose} aria-hidden="true" />

      {/* Ventana Modal Oficial de la Muestra */}
      <div className="df-legal-modal-dialog">
        {/* Cabecera Oficial */}
        <div className="df-legal-modal-header">
          <div className="df-legal-modal-header-titles">
            <span className="df-legal-modal-tag">{currentDoc.tag}</span>
            <h2 id="df-legal-modal-title" className="df-legal-modal-title">
              {currentDoc.title}
            </h2>
          </div>

          <button
            type="button"
            className="df-legal-modal-close-btn"
            onClick={onClose}
            aria-label="Cerrar modal"
          >
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round">
              <path d="M6 6l12 12M18 6L6 18" />
            </svg>
          </button>
        </div>

        {/* Cuerpo con Scroll Oficial */}
        <div
          className="df-legal-modal-body"
          dangerouslySetInnerHTML={{ __html: currentDoc.bodyHtml }}
        />
      </div>
    </div>
  );
};

export default ModalLegal;
